import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { multiPeriodCompare } from "@/api/dataAll/dataAll";
import { mapState } from 'vuex';
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "timePeriodDataComparison",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      timeList: [{
        label: this.$t('timeDay'),
        id: "day"
      }, {
        label: this.$t('timeWeek'),
        id: "week"
      }, {
        label: this.$t('timeMonth'),
        id: "month"
      }],
      currentMonth: '',
      searchData: {
        user_type: "register",
        period_type: 'day',
        // 默认选中天
        //天
        base_day: '',
        compare_days: [],
        //周
        base_year_month: '',
        base_week: '',
        compare_items: [{
          year_month: '',
          week: ''
        }],
        //月
        base_month: '',
        compare_months: []
      },
      tableList: [],
      serverList: [],
      // 多余
      displayMode: 'both',
      // both, count, ratio
      lastRawList: null,
      metricColumns: [{
        label: this.$t('activateDeviceNum'),
        prop: 'activate_devices'
      }, {
        label: this.$t('registerDevices'),
        prop: 'register_devices'
      }, {
        label: this.$t('registerNum'),
        prop: 'register_accounts'
      }, {
        label: this.$t('activeUserCount'),
        prop: 'active_users'
      }, {
        label: this.$t('payUsers'),
        prop: 'pay_users'
      }, {
        label: this.$t('payAmount'),
        prop: 'pay_amount'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })), {}, {
    pickerOptionsDisableFuture: function pickerOptionsDisableFuture() {
      return {
        disabledDate: function disabledDate(time) {
          // time.getTime() > Date.now() 即禁用今天之后的时间
          return time.getTime() > Date.now();
        }
      };
    },
    // 💡 2. 天：禁止选择基准天 + 禁止选择未来时间
    pickerOptionsCompareDay: function pickerOptionsCompareDay() {
      var baseDay = this.searchData.base_day;
      return {
        disabledDate: function disabledDate(time) {
          // 禁止未来时间
          if (time.getTime() > Date.now()) return true; // 禁止选择基准天

          if (!baseDay) return false;
          var year = time.getFullYear();
          var month = String(time.getMonth() + 1).padStart(2, '0');
          var day = String(time.getDate()).padStart(2, '0');
          return "".concat(year, "-").concat(month, "-").concat(day) === baseDay;
        }
      };
    },
    pickerOptionsCompareMonth: function pickerOptionsCompareMonth() {
      var baseMonth = this.searchData.base_month;
      return {
        disabledDate: function disabledDate(time) {
          // 禁止未来月份
          if (time.getTime() > Date.now()) return true; // 禁止选择基准月

          if (!baseMonth) return false;
          var year = time.getFullYear();
          var month = String(time.getMonth() + 1).padStart(2, '0');
          return "".concat(year, "-").concat(month) === baseMonth;
        }
      };
    }
  }),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  watch: {
    displayMode: function displayMode() {
      if (this.lastRawList) {
        this.searchClickNew(this.lastRawList);
      }
    }
  },
  methods: {
    isFutureWeek: function isFutureWeek(yearMonthStr, weekNum) {
      if (!yearMonthStr || !weekNum) return false;
      var now = new Date();
      var currentYearMonth = "".concat(now.getFullYear(), "-").concat(String(now.getMonth() + 1).padStart(2, '0')); // 如果选择的年月比当前年月大，肯定是未来周

      if (yearMonthStr > currentYearMonth) return true; // 如果是当月，按当月第几天推算当前属于第几周（7天为一周）

      if (yearMonthStr === currentYearMonth) {
        var currentDay = now.getDate();
        var currentWeek = Math.ceil(currentDay / 7);
        return weekNum > currentWeek; // 大于当前周则禁用
      }

      return false;
    },
    isWeekOptionDisabled: function isWeekOptionDisabled(yearMonth, week, currentIndex) {
      if (!yearMonth || !week) return false; // 1. 校验：不能是未来周

      if (this.isFutureWeek(yearMonth, week)) {
        return true;
      } // 2. 校验：不能与基准周重复


      var _this$searchData = this.searchData,
          base_year_month = _this$searchData.base_year_month,
          base_week = _this$searchData.base_week;

      if (yearMonth === base_year_month && week === base_week) {
        return true;
      } // 3. 校验：不能与【其他对比项】已选的“年月-周”重复


      var isDuplicateWithOthers = this.searchData.compare_items.some(function (item, index) {
        // 排除当前正在选择的这一行本身
        if (index === currentIndex) return false; // 检查是否有其他行选了相同的 年月 和 周

        return item.year_month === yearMonth && item.week === week;
      });
      return isDuplicateWithOthers;
    },
    validateWeekItem: function validateWeekItem(item, index) {
      if (!item.year_month || !item.week) return; // 如果选中的组合已被禁用（如：先选了周，后来修改了年月导致与前面重复）

      if (this.isWeekOptionDisabled(item.year_month, item.week, index)) {
        item.week = '';
        this.$message.warning(this.$t('timePeriodExists'));
      }
    },
    handleMonthChange: function handleMonthChange(val) {
      // 当选择了一个新月份，且它不在已选列表中，则添加
      if (val && !this.searchData.compare_months.includes(val)) {
        this.searchData.compare_months.push(val);
      } // 清空当前选择的值，以便再次选择


      this.currentMonth = '';
    },
    removeMonth: function removeMonth(index) {
      this.searchData.compare_months.splice(index, 1);
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    handleTimeTypeChange: function handleTimeTypeChange() {
      this.searchData.base_day = '';
      this.searchData.compare_days = [];
      this.searchData.base_year_month = '';
      this.searchData.base_week = '';
      this.searchData.base_month = '';
      this.searchData.compare_months = [];
      this.searchData.compare_items = [{
        year_month: '',
        week: ''
      }];
    },
    addCompareItem: function addCompareItem() {
      this.searchData.compare_items.push({
        year_month: '',
        week: ''
      });
    },
    removeCompareItem: function removeCompareItem(index) {
      if (this.searchData.compare_items.length > 1) {
        this.searchData.compare_items.splice(index, 1);
      }
    },
    searchClick: function searchClick() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, params, days, periodValues, month, searchCurrency;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = JSON.parse(JSON.stringify(_this2.searchData));
                params = {
                  server_id: _this2.paramsData.server_id.length ? _this2.paramsData.server_id.join(",") : '',
                  game_id: _this2.rawData.game_id,
                  period_type: data.period_type,
                  special_product_id: _this2.searchData.special_product_id.length ? _this2.searchData.special_product_id.join(",") : ''
                };
                console.log("this.searchData==", _this2.searchData);

                if (data.period_type == 'day') {
                  days = [data.base_day];

                  if (data.compare_days && data.compare_days.length) {
                    days = days.concat(data.compare_days);
                  }

                  params.period_values = days.join(',');
                }

                if (data.period_type == 'week') {
                  periodValues = []; // 1. 基准周：base_year_month + base_week

                  if (data.base_year_month && data.base_week) {
                    periodValues.push("".concat(data.base_year_month, "-W").concat(data.base_week));
                  } // 2. 对比周：compare_items 数组中的 year_month + week


                  if (data.compare_items && data.compare_items.length) {
                    data.compare_items.forEach(function (item) {
                      if (item.year_month && item.week) {
                        periodValues.push("".concat(item.year_month, "-W").concat(item.week));
                      }
                    });
                  }

                  params.period_values = periodValues.join(',');
                }

                if (data.period_type == 'month') {
                  month = [data.base_month];

                  if (data.compare_months && data.compare_months.length) {
                    month = month.concat(data.compare_months);
                  }

                  params.period_values = month.filter(Boolean).join(',');
                }

                console.log("params===", params);
                searchCurrency = _this2.$store.state.d2admin.serchSelect.searchCurrency;

                if (searchCurrency.length) {
                  params.currency_info = _this2.defaultData().currency_info;
                }

                _this2.reqLoading = true;
                multiPeriodCompare(params).then(function (res) {
                  _this2.reqLoading = false;

                  if (res.code == 200) {
                    var _data = res.data;
                    var list = [];

                    if (_data.base_period) {
                      var baseRow = {
                        date: _data.base_period.date,
                        is_base: true // 标记为基准数据

                      };

                      _this2.metricColumns.forEach(function (col) {
                        var _data$base_period$met;

                        var rawVal = _data.base_period.metrics ? (_data$base_period$met = _data.base_period.metrics[col.prop]) !== null && _data$base_period$met !== void 0 ? _data$base_period$met : 0 : 0;
                        rawVal = Number(rawVal) || 0;

                        if (col.prop == 'pay_amount') {
                          rawVal = rawVal / 100;
                        }

                        baseRow[col.prop] = {
                          value: rawVal,
                          diff: 0
                        };
                      });

                      list.push(baseRow);
                    } // 2. 处理对比列表 (comparisons)


                    if (Array.isArray(_data.comparisons)) {
                      _data.comparisons.forEach(function (item) {
                        var row = {
                          date: item.date,
                          is_base: false
                        };

                        _this2.metricColumns.forEach(function (col) {
                          var metricsVal = item.metrics ? item.metrics[col.prop] : 0;
                          var compareItem = item.compare_with_base ? item.compare_with_base[col.prop] : null;
                          var val = compareItem ? compareItem.current : metricsVal;
                          var diff = compareItem ? compareItem.diff : 0;
                          var growthRate = compareItem ? compareItem.growth_rate : 0;
                          val = Number(val) || 0;
                          diff = Number(diff) || 0; // 如果是付费金额，原值和差值均除以 100

                          if (col.prop === 'pay_amount') {
                            val = val / 100;
                            diff = diff / 100;
                          }

                          row[col.prop] = {
                            value: val,
                            diff: diff,
                            growthRate: growthRate
                          };
                        });

                        list.push(row);
                      });
                    }

                    _this2.tableData = list;
                    console.log("this.tableData==", _this2.tableData);
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exportdata: function exportdata() {
      var _this3 = this;

      if (!this.tableData.length) return; // 1. 组装 Excel 表头

      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }].concat(_toConsumableArray(this.metricColumns.map(function (col) {
        return {
          label: col.label,
          prop: col.prop
        };
      }))); // 2. 映射表体数据

      var data = this.tableData.map(function (row) {
        var formattedRow = {
          date: row.is_base ? "".concat(row.date, " (").concat(_this3.$t('baseLabel'), ")") : row.date
        };

        _this3.metricColumns.forEach(function (col) {
          var cell = row[col.prop];

          if (!cell) {
            formattedRow[col.prop] = '-';
            return;
          }

          if (row.is_base) {
            formattedRow[col.prop] = "".concat(cell.value);
          } else {
            var diffSymbol = cell.diff > 0 ? '+' : '';
            var rateSymbol = cell.growthRate > 0 ? '+' : '';
            formattedRow[col.prop] = "".concat(cell.value, " (").concat(diffSymbol).concat(cell.diff, ")(").concat(rateSymbol).concat(cell.growthRate, "%)");
          }
        });

        return formattedRow;
      }); // 3. 执行导出

      this.$export.excel({
        columns: columns,
        data: data,
        title: "".concat(this.$route.meta.title || this.$t('multiPeriodDataCompare'), "}")
      });
    }
  }
};